module.exports = __webpack_public_path__ + "img/Badge_PLATINA.4ff79461.png";